// extracted by mini-css-extract-plugin
export default {"ConsentForm":"Consent_ConsentForm__eu0T4","FormError":"Consent_FormError__BMyG2"};